import {
  ORDENESTUDIO_ERROR,
  ORDENESTUDIO_LOADING,
  ORDENESTUDIO_SUCCESS,
  ORDENESTUDIO_RESET,
  ORDENESTUDIO_ELIMINAR,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "global/helpers/axiosLogin";

export const wsPostSubirOrden = (ordenDto, next) => (dispatch) => {
  dispatch({
    type: ORDENESTUDIO_LOADING,
  });
  axiosLogin().then((respuesta) => {
    respuesta
      .post("dis/informes/ordenes", ordenDto)
      .then((res) => {
        // onClose();
        dispatch({
          type: ORDENESTUDIO_SUCCESS,
          payload: res.data,
        });
        if (next) next(true);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "portal",
        };
        if (next) next(false);
        dispatch({
          type: ORDENESTUDIO_ERROR,
          payload: error,
        });
      });
  });
};
export const wsDeleteOrdenEstudio = (id, idremoto, nextStep) => (dispatch) => {
  dispatch({
    type: ORDENESTUDIO_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .delete(`/dis/informes/ordenes/${id}`)
      .then((res) => {
        if (nextStep) nextStep();
        dispatch({
          type: ORDENESTUDIO_ELIMINAR,
          payload: res.data,
        });
      })
      .catch((err) => {
        if (nextStep) nextStep();
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "portal",
        };

        dispatch({
          type: ORDENESTUDIO_ERROR,
          payload: error,
        });
      });
  });
};

export const resetOrdenEstudio = () => (dispatch) => {
  dispatch({
    type: ORDENESTUDIO_RESET,
  });
};

export const wsPostOrdenConFirmaDigital = (data, ordenDigital, next) => (dispatch) => {
  dispatch({ type: ORDENESTUDIO_LOADING });
  axiosLogin().then((respuesta) => {
    respuesta
      .post(`his/turnos/ordenConFirmaDigital/${ordenDigital ? ordenDigital : ""}`, data)
      .then((resp) => {
        dispatch({ type: ORDENESTUDIO_SUCCESS, payload: resp.data });
        if(next) next(true);
      })
      .catch((err) => {
        dispatch({ type: ORDENESTUDIO_ERROR, payload: err });
        if(next) next(false);
      });
  });
};

export const wsPostOrdenConFirmaDigitalLabo = (data, ordenDigital, next) => (dispatch) => {
  dispatch({ type: ORDENESTUDIO_LOADING });
  axiosLogin().then((respuesta) => {
    respuesta
      .post(`/lis/laboratorio/ordenConFirmaDigital/${ordenDigital ? ordenDigital : ""}`, data)
      .then((resp) => {
        dispatch({ type: ORDENESTUDIO_SUCCESS, payload: resp.data });
        if (next) next(true);
      })
      .catch((err) => {
        dispatch({ type: ORDENESTUDIO_ERROR, payload: err });
        if (next) next(false);
      });
  });
};

export const wsPostOrdenAsistencia = (data, next) => (dispatch) => {
  dispatch({ type: ORDENESTUDIO_LOADING });
  axiosInstance().then((respuesta) => {
    respuesta
      .post("/asistenciaDocumento/altaOrden", data)
      .then((resp) => {
        dispatch({ type: ORDENESTUDIO_SUCCESS, payload: resp.data });
        if (next) next(true);
      })
      .catch((err) => {
        dispatch({ type: ORDENESTUDIO_ERROR, payload: err });
        if (next) next(false);
      });
  });
};
